import { createI18n } from "vue-i18n";
import de from "./de.json";
import en from "./en.json";
import tr from "./tr.json";

const STORAGE_KEY = "sc-locale";
const supported = ["tr", "en", "de"];

function initialLocale() {
  if (typeof window === "undefined") return "tr";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (supported.includes(saved)) return saved;
  return "tr";
}

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: "tr",
  messages: { tr, en, de },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.global.locale.value === "tr" ? "tr" : i18n.global.locale.value;
}

export function setLocale(locale) {
  if (!supported.includes(locale)) return;
  i18n.global.locale.value = locale;
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, locale);
    document.documentElement.lang = locale === "tr" ? "tr" : locale;
  }
}
